/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var People3Icon24Solid = forwardRef('People3Icon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" }),
        React.createElement("path", { d: "M20 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" }),
        React.createElement("path", { d: "M5 18.5a5.5 5.5 0 0 1 5.5-5.5h3a5.5 5.5 0 0 1 5.5 5.5v1a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 5 19.5v-1Z" }),
        React.createElement("path", { d: "M5.132 14.007A6.972 6.972 0 0 0 3.5 18.5v1c0 .17.014.337.041.5H1.833C.821 20 0 19.155 0 18.112c0-1.585.839-2.887 2.252-3.503.832-.363 1.847-.564 2.88-.602Z" }),
        React.createElement("path", { d: "M20.459 20c.027-.163.041-.33.041-.5v-1c0-1.71-.613-3.277-1.632-4.493 1.033.038 2.048.239 2.88.602C23.16 15.225 24 16.527 24 18.112 24 19.155 23.18 20 22.167 20h-1.709Z" }),
        React.createElement("path", { d: "M7 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" })));
});
